/**
 * Chromium quirk: ResizeObserver callbacks that mutate layout in the same frame
 * trigger "ResizeObserver loop completed with undelivered notifications".
 * Apollo/MUI tables and tabs hit this harmlessly; CRA's dev overlay treats it
 * as a fatal runtime error.
 *
 * Import this module before any other app imports (see index.js).
 */

const RESIZE_OBSERVER_LOOP_RE = /ResizeObserver loop/;

function isResizeObserverLoopError(event) {
  const msg = String(
    event?.message || event?.error?.message || event?.reason?.message || ''
  );
  return RESIZE_OBSERVER_LOOP_RE.test(msg);
}

function installResizeObserverLoopFix() {
  if (
    typeof window === 'undefined' ||
    typeof window.ResizeObserver === 'undefined'
  ) {
    return;
  }
  if (window.ResizeObserver.__wfeLoopFixInstalled) {
    return;
  }

  const NativeResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };

  window.ResizeObserver.__wfeLoopFixInstalled = true;
}

function suppressResizeObserverLoopErrorOverlay() {
  if (
    typeof window === 'undefined' ||
    window.__wfeResizeObserverErrorSuppressed
  ) {
    return;
  }

  window.addEventListener(
    'error',
    (event) => {
      if (!isResizeObserverLoopError(event)) {
        return;
      }
      event.stopImmediatePropagation();
      event.preventDefault();
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (!isResizeObserverLoopError(event)) {
        return;
      }
      event.stopImmediatePropagation();
      event.preventDefault();
    },
    true
  );

  window.__wfeResizeObserverErrorSuppressed = true;
}

installResizeObserverLoopFix();
suppressResizeObserverLoopErrorOverlay();
